import { reatomAsync } from "@reatom/async";
import axios from "axios";
import { withIsLoadingAtom } from "src/common/pipes";
import { toastHandler } from "src/util";

import { type ICunsultationFormInput } from "../../ConsultationWidget.types";

export const consultationRequestAtom = reatomAsync(
  async (ctx, form: ICunsultationFormInput, url) => {
    const response = await axios.post(url, form, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.data?.success) {
      toastHandler.success({
        name: "Запись на косультацию",
        title: "Запись на косультацию",
        content: "Вы успешно записались на консультацию",
      });
    } else {
      toastHandler.error({
        name: "Запись на косультацию",
        title: "Запись на косультацию",
        content: "Что-то пошло не так",
      });
    }
  },
  "consultationRequest",
).pipe(withIsLoadingAtom());
